package pwgs.ui.scenes.playerslistscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class APlayersListControllerFe(props: pwgs.ui.scenes.playerslistscene.PlayersListSceneProps, scene: MPlayersListScene)
 : AController<pwgs.ui.scenes.playerslistscene.PlayersListSceneProps, pwgs.ui.scenes.playerslistscene.PlayersListSceneModel, PlayersListSceneState>(props, scene) {

    val backend = PlayersListControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class PlayersListControllerBeProxy(private val controller: APlayersListControllerFe) {

    suspend fun load(): pwgs.ui.scenes.playerslistscene.PlayersListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerslistscene.PlayersListControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerslistscene.PlayersListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerslistscene.PlayersListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerslistscene.PlayersListSceneModel.serializer())
        }
    }

}
